import React, { PropTypes } from 'react';
import Controls from 'components/Page/Controls';
import ClassNames from 'classnames';
import * as MaterialIcons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';

export default (Component, options) => {
  options = options || {};
  return class ControlledComponent extends React.Component {
    constructor() {
      super(...arguments);
      this.state = {
        mode: this.props.mode || 'detail',
        shown: false
      };
    }

    show() {
      if (!this.state.shown) {
        this.setState({ shown: true });
      }
    }

    hide() {
      if (this.state.mode === 'detail' && this.state.shown) {
        this.setState({ shown: false });
      }
    }

    _onEditMenu() {
      if (this.refs.component.edit) {
        this.refs.component.edit();
      }
      this.setState({
        mode: 'edit'
      });
    }

    _onDefaultMenu() {
      this.setState({
        mode: 'detail'
      });
    }

    _onSettings() {
      console.log('TODO : implement settings');
    }

    _onCancel() {
      if (this.refs.component.cancel) {
        this.refs.component.cancel();
      }
      this.setState({
        mode: 'detail'
      });
    }

    _onDelete() {
      if (this.refs.component.delete) {
        this.refs.component.delete();
      }
      // ??
    }

    _onAttach() {
      if (this.refs.component.attach) {
        this.refs.component.attach();
      }
    }

    _onSave() {
      if (this.refs.component.save) {
        this.refs.component.save();
      }
      this.setState({
        mode: 'detail'
      });
    }

    _onUploadSuccess(data) {
      if (this.refs.component.attach) {
        this.refs.component.attach(data);
      }
    }

    _onProgress(event) {
      if (this.refs.component.progress) {
        this.refs.component.progress(event);
      }
    }

    _handler(func, payload) {
      if (this.refs.component[func]) {
        this.refs.component[func](payload);
      }
    }

    createControls(menuItems) {
      if (this.props.builder || true) {
        return (
          <Controls
            encoded={options.encoded || false}
            multiple={options.multiple || false}
            defaultMenu={this.props.defaultMenu}
            ref="controls"
            menuItems={menuItems}
            onSave={this._onSave.bind(this)}
            onDelete={this._onDelete.bind(this)}
            onSettings={this._onSettings.bind(this)}
            onEditMenu={this._onEditMenu.bind(this)}
            onDefaultMenu={this._onDefaultMenu.bind(this)}
            onCancel={this._onCancel.bind(this)}
            onAttach={this._onAttach.bind(this)}
            onProgress={this._onProgress.bind(this)}
            handler={this._handler.bind(this)}
            onUploadSuccess={this._onUploadSuccess.bind(this)}
          />
        );
      } else {
        return null;
      }
    }

    render() {
      var standardMenuItems = options.menuItems || {
        default: [
          {
            menu: 'edit',
            icon: (
              <MaterialIcons.ContentCreate color={Colors.Colors.fullBlack} />
            )
          }
        ],
        edit: [
          {
            onTouchTap: 'save',
            icon: <MaterialIcons.ActionDone color={Colors.Colors.fullBlack} />
          },
          {
            onTouchTap: 'cancel',
            icon: <MaterialIcons.ContentClear color={Colors.Colors.fullBlack} />
          },
          {
            onTouchTap: 'delete',
            icon: <MaterialIcons.ActionDelete color={Colors.Colors.fullBlack} />
          }
        ]
      };
      let menuItems = {
        default: standardMenuItems.default.slice(),
        edit: standardMenuItems.edit.slice()
      };
      if (options.attach) {
        menuItems.edit.push({
          attach: true,
          accept: options.attach,
          onTouchTap: 'attach'
        });
      }
      let controls;
      if (this.state.shown || this.props.defaultMenu) {
        controls = this.createControls(menuItems);
      }
      return (
        <Component
          ref="component"
          {...this.props}
          mode={this.state.mode}
          onMouseEnter={this.show.bind(this)}
          onMouseLeave={this.hide.bind(this)}
        >
          {this.props.children}
          {controls}
        </Component>
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/js/components/Mixins/ControlsMixin.js